import { createAsyncThunk } from "@reduxjs/toolkit";
import { addSearchHistory, clearSearchHistory, getSearchHistory } from "store/services/search";
import { openToast } from "store/slices/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetSearchHistoryAction = createAsyncThunk(
    "search/getSearchHistory",
    async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
        try {
            const response = await getSearchHistory(payload);
            if (response.status === 1) {
                return fulfillWithValue(response);
            }
            dispatch(
                openToast({
                    type: "error",
                    message: getApiMessage(response?.statusCode),
                }),
            );
            return rejectWithValue(response);
        } catch (error) {
            dispatch(
                openToast({
                    type: "error",
                    message: error?.response?.data?.statusCode
                        ? getApiMessage(error?.response?.data?.statusCode)
                        : error?.message,
                }),
            );
            return rejectWithValue(error);
        }
    },
);

export const ClearSearchHistoryAction = createAsyncThunk(
    "search/clearSearchHistory",
    async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
        try {
            const response = await clearSearchHistory(payload);
            if (response.status === 1) {
                return fulfillWithValue(response);
            }
            dispatch(
                openToast({
                    type: "error",
                    message: getApiMessage(response?.statusCode),
                }),
            );
            return rejectWithValue(response);
        } catch (error) {
            dispatch(
                openToast({
                    type: "error",
                    message: error?.response?.data?.statusCode
                        ? getApiMessage(error?.response?.data?.statusCode)
                        : error?.message,
                }),
            );
            return rejectWithValue(error);
        }
    },
);


export const AddSearchHistoryAction = createAsyncThunk(
    "search/addSearchHistory",
    async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
        try {
            const response = await addSearchHistory(payload);
            if (response.status === 1) {
                return fulfillWithValue(response);
            }
            dispatch(
                openToast({
                    type: "error",
                    message: getApiMessage(response?.statusCode),
                }),
            );
            return rejectWithValue(response);
        } catch (error) {
            dispatch(
                openToast({
                    type: "error",
                    message: error?.response?.data?.statusCode
                        ? getApiMessage(error?.response?.data?.statusCode)
                        : error?.message,
                }),
            );
            return rejectWithValue(error);
        }
    },
);